export default "__VITE_ASSET__Ch5jlZ$M__"